import React from 'react';
import styles from './GenericToast.module.css';
import { ReactComponent as CloseIcon } from '../icons/close_icon.svg';

export const GenericToast: React.FC<{
    text: string;
    setStatus: (status: number | undefined) => void;
}> = ({ text, setStatus }) => {
    return (
        <div id={'outer-toast'} className={styles.toastContainer}>
            <div
                id="inner-toast"
                className={styles.toast}
                aria-live="polite"
                role="alert"
            >
                <p>{text}</p>
                <button
                    id="toast-close-button"
                    className={styles.toastClose}
                    aria-label="close-toast-button"
                    onClick={() => setStatus(undefined)}
                >
                    <CloseIcon />
                </button>
            </div>
        </div>
    );
};
